export default "__VITE_ASSET__BYDNrpSL__"